<div class="row mt-3">
  <div class="col-md-6">
    <form [formGroup]="form" class="" novalidate>
      <div class="form-group">
        <label class="text-muted" i18n>Allow AI to consume date from below website.</label>
        <input class="form-control" formControlName="url" type="url" required placeholder="https://example.com" />
        <div class="invalid-feedback d-block" *ngIf="form.get('url').hasError('required') && form.get('url').touched">
          <ng-container i18n>Url is required</ng-container>
        </div>
        <div class="invalid-feedback d-block" *ngIf="form.get('url').hasError('url')" i18n>Url is invalid</div>
      </div>
      <button class="btn btn-secondary-info text-nowrap" (click)="onSave(form)" [disabled]="isLoading$ | async">
        <i class="cs-icon cs-icon-left-down"></i> <ng-container i18n>Add To List</ng-container>
      </button>
    </form>
  </div>
</div>
<div class="border rounded overflow-hidden mt-3 bg-white">
  <mat-table #table matSort [dataSource]="dataSource">
    <ng-container matColumnDef="url">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>URL</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.url }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="title">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Title</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.title }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="edit">
      <mat-header-cell *matHeaderCellDef i18n>Action</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <a
          href="javascript:;"
          (click)="onDelete(element)"
          i18n-matTooltip
          matTooltip="Delete this website"
          class="text-danger"
          ><i class="cs-icon cs-icon-trash"></i
        ></a>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
  <app-empty-table type="AIWebsites" *ngIf="!dataSource.data?.length"></app-empty-table>

  <mat-paginator2
    #paginator
    [length]="dataSource?.data?.length"
    [pageSizeOptions]="[5, 10, 20, 50]"
    [showFirstLastButtons]="true"
  >
  </mat-paginator2>
</div>
